import { IForm } from 'core-components/classes/models/IForm'
import { searchReducer } from './reducer'
import { ISearchState, StoreForms } from './state'

let store: any

export const setApplicationStore = (applicationStore: any) =>
  (store = applicationStore)

export const searchGetState = (): ISearchState => store.getState().search

export const save = (
  formId: string,
  query: string,
  data: { items: IForm[]; total: number }
) => {
  store.dispatch({
    formId: StoreForms[formId],
    query,
    data,
    type: '@SEARCH_SAVE',
    state: searchGetState(),
  })
}

export const read = (formId: StoreForms, query: string) => {
  const store = searchGetState()
  let res
  try {
    res = store.forms[formId].queries[query]
  } catch (e) {}
  return res
}

export const remove = (formId: StoreForms, EntryId: number) => {
  store.dispatch({
    formId,
    EntryId,
    type: '@SEARCH_REMOVE',
    state: searchGetState(),
  })
}
const res = { search: searchReducer }
export { res as reducer }
